import { useState, useEffect } from 'react'

import { getAssignedExperimentBucket } from '@src/experiments'

const useExperimentBucket = (experimentName: string, defaultBucket = 'control') => {
  const [experimentBucket, setExperimentBucket] = useState<string>(defaultBucket)

  useEffect(() => {
    const bucket = getAssignedExperimentBucket(experimentName)
    setExperimentBucket(bucket)
  }, [experimentName])

  return experimentBucket
}

export default useExperimentBucket
